export enum StatementRecipientLabel {
  CLIENT = 'client',
  CONTACT = 'billing contact',
}
